export const SANITIZED_PLAYER = {
  INSTANCE: '<<PLAYER_INSTANCE>>',
  ELEMENT: '<<PLAYER_ELEMENT>>',
};

export const HOME_KIDS_PATHNAME = '/home-kids/';
